import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { HeadComponent } from '../../HeadComponent';
import FaqThemeComponent from './FaqThemeComponent';
import { withTemplate } from '../../template/withTemplate';
import { fetchFaqIfNeeded } from '../../../services/faq/actions';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import { withLoadingCondition } from '../../loading/withLoadingCondition';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './FaqThemeComponent.scss';

const parseHashIdfromQuery = hash => {
    const number = Number(hash.slice(1));
    return number && !isNaN(number) ? number : null;
};

export class FaqPage extends React.Component {
    componentDidMount() {
        this.props.fetchFaqIfNeeded();
    }

    componentWillMount() {
        document.body.classList.add('fullHeight');
    }

    componentWillUnmount() {
        document.body.classList.remove('fullHeight');
    }

    renderFaqs = () => {
        const { data, location } = this.props;
        if (data) {
            return data.map(theme => {
                return (
                    theme.faqs.length > 0 && (
                        <FaqThemeComponent
                            key={theme.id}
                            theme={theme}
                            hashId={parseHashIdfromQuery(location.hash)}
                        />
                    )
                );
            });
        }
    };

    render() {
        const { i18n, loading = false } = this.props;

        return (
            <React.Fragment>
                <main className="conteneur conteneur-mobile" id="p-faq">
                    <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                    <LocalizedBreadcrumbItem to={PATH.FAQ_PATH}>
                        {i18n.BREADCRUMB}
                    </LocalizedBreadcrumbItem>
                    <h1>{i18n.PAGE_TITLE}</h1>
                    {withLoadingCondition(loading, this.renderFaqs)}
                </main>
            </React.Fragment>
        );
    }
}

FaqPage.propTypes = {
    i18n: PropTypes.object.isRequired,
    data: PropTypes.array,
    loading: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.FAQ,
        data: state.faq.faqs || [],
        loading: state.faq.fetching
    };
};

const mapDispatchToProps = {
    fetchFaqIfNeeded
};

export default withTemplate(connect(mapStateToProps, mapDispatchToProps)(FaqPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/faq/FaqPage.js